import React, { ReactNode, useEffect, useRef, useState } from 'react'

import { usePathname } from 'next/navigation'

import { MarginProps } from 'styled-system'

import { useInView } from 'framer-motion'

import { ANIMATION } from 'Constants/Animation'
import { ROOT } from 'Constants/Paths'

import { Container } from './styles'

type Props = MarginProps & {
  children: ReactNode
  initial?: string
  isAnimate?: boolean
  variants?: any
  wayPointTop?: boolean
}

const Wrapper = ({
  isAnimate,
  children,
  initial = 'closed',
  variants = ANIMATION.parentVariants,
  wayPointTop,
  ...rest
}: Props) => {
  const pathname = usePathname()
  const ref = useRef(null)

  const isInView = useInView(ref, { once: true, margin: '-50px' })

  const [isVisible, setVisible] = useState(false)

  useEffect(() => {
    if (isInView && isAnimate) {
      setVisible(true)
    }
  }, [isAnimate, isInView])

  const isRootPage = pathname === ROOT

  return (
    <Container
      animate={isVisible ? 'open' : 'closed'}
      column={wayPointTop}
      initial={initial}
      ref={ref}
      variants={variants}
      wideContent={isRootPage}
      {...rest}
    >
      {children}
    </Container>
  )
}

export default Wrapper
